/** @format */

import { Component } from '@angular/core';

@Component({
	selector: 'plp-components-promotion',
	templateUrl: './promotion.component.html',
	styleUrl: './promotion.component.scss'
})
export class PromotionComponent {}
